import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../services/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Mail, Loader2, ArrowLeft, MailCheck } from 'lucide-react';
import { toast } from 'sonner';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ai-gym-guide/artifacts/gwvje8fa_IMG_20220211_145748_413%20%285%29.jpg";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('Indica o teu email');
      return;
    }

    setLoading(true);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Não foi possível enviar o email. Tenta novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center p-6 sm:p-8 pb-24 sm:pb-8">
      <div className="w-full max-w-md" data-testid="forgot-password-page">
        <div className="mb-12 flex justify-center">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Process Body" className="w-14 h-14 rounded-full object-cover" />
            <span className="text-3xl font-bold tracking-tight" style={{ fontFamily: 'Barlow Condensed' }}>
              PROCESS<span className="text-[#32CD32]">BODY</span>
            </span>
          </Link>
        </div>

        {sent ? (
          <div className="text-center" data-testid="forgot-password-sent">
            <div className="w-16 h-16 rounded-full bg-[#32CD32]/15 border border-[#32CD32]/30 flex items-center justify-center mx-auto mb-6">
              <MailCheck className="w-8 h-8 text-[#32CD32]" />
            </div>
            <h1
              className="text-3xl font-bold tracking-tight uppercase mb-3"
              style={{ fontFamily: 'Barlow Condensed' }}
            >
              Verifica o teu email
            </h1>
            <p className="text-gray-400 mb-2">
              Se existir uma conta associada a <span className="text-white">{email}</span>, enviámos um link
              para definires uma nova palavra-passe.
            </p>
            <p className="text-sm text-gray-500 mb-8">
              O link é válido durante 1 hora. Não te esqueças de verificar a pasta de spam.
            </p>
            <Link
              to="/login"
              className="inline-flex items-center gap-2 text-[#32CD32] hover:underline"
              data-testid="forgot-password-back-to-login"
            >
              <ArrowLeft className="w-4 h-4" />
              Voltar ao login
            </Link>
          </div>
        ) : (
          <>
            <div className="mb-8">
              <h1
                className="text-3xl font-bold tracking-tight uppercase mb-2"
                style={{ fontFamily: 'Barlow Condensed' }}
              >
                Recuperar acesso
              </h1>
              <p className="text-gray-400">
                Escreve o email da tua conta e enviamos-te um link para criares uma nova palavra-passe.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="email" className="text-sm font-medium text-gray-300">
                  Email
                </Label>
                <div className="relative">
                  <Mail className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" />
                  <Input
                    id="email"
                    type="email"
                    placeholder="seu@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="pl-12 h-14 bg-[#121212] border-white/10 rounded-xl text-white placeholder:text-gray-500"
                    data-testid="forgot-password-email-input"
                  />
                </div>
              </div>

              <Button
                type="submit"
                className="w-full btn-primary h-14 rounded-xl text-lg"
                disabled={loading}
                data-testid="forgot-password-submit-btn"
              >
                {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : 'ENVIAR LINK'}
              </Button>
            </form>

            <div className="mt-8 text-center">
              <Link
                to="/login"
                className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors"
                data-testid="forgot-password-login-link"
              >
                <ArrowLeft className="w-4 h-4" />
                Voltar ao login
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
